













































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import numUtils from "@/utils/numUtils";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import * as casinoTypes from "@/store/constants/casinoConstants";
import SkipDelayCount from "../skipDelayCount/SkipDelayCount.vue";
import {localizedPrice} from "@/utils/localizedUtil.ts";
@Component({
  components: {
    SkipDelayCount
  }
})
export default class FeedOffer extends Vue {
  @Getter(types.GETTER_INFO_BY_OFFER_DATA)
  private offerInfo: any;
  @Getter(types.GETTER_CASINO_HIGHEST_REWARD)
  private getHighestReward: any;
  @Getter(types.GETTER_LOCALIZE_PRICE)
  private localizePrice: any;
  @Getter(types.GETTER_SETTING_DATA)
  private settginData: any;
  @Prop({
    default: "spin"
  })
  private type: any;
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;

  get spinCoin() {
    const reward = this.getHighestReward(casinoTypes.CASINO_GAME_SPIN);
    return reward && reward.reward ? reward.reward : 0;
  }

  get format() {
    return numUtils.format;
  }

  get diceCoin() {
    const reward = this.getHighestReward(casinoTypes.CASINO_GAME_DICE);
    return reward && reward.reward ? reward.reward : 0;
  }

  get slotsCoin() {
    const reward = this.getHighestReward(casinoTypes.CASINO_GAME_SLOTS);
    return reward && reward.reward ? reward.reward : 0;
  }

  get luckyCoin() {
    return this.settginData.lucky_coin_offers[0];
  }

  get winCoins() {
    switch (this.type) {
      case "spin":
        return this.spinCoin;
      case "slot":
        return this.slotsCoin;
      case "sic":
        return this.diceCoin;
      default:
        return "";
    }
  }

  get titleText() {
    switch (this.type) {
      case "spin":
        return "Lucky Draw";
      case "slot":
        return "Lucky Slot";
      case "sic":
        return "Sic Bo";
      case "ads":
        return "Watch a Short Video";
      case "lucky":
        return "Lucky Offer Reward";
      default:
        return "";
    }
  }

  get titleStyle() {
    switch (this.type) {
      case "spin":
        return {
          background:
            "linear-gradient(to left, rgb(52,119,255), rgb(56,159,255)",
          color: "transparent",
          webkitBackgroundClip: "text"
        };
      case "slot":
        return {
          background: "linear-gradient(to left, rgb(255,202,0), rgb(255,169,0)",
          color: "transparent",
          webkitBackgroundClip: "text"
        };
      case "sic":
        return {
          background:
            "linear-gradient(to left, rgb(239,102,24), rgb(255,148,90)",
          color: "transparent",
          webkitBackgroundClip: "text"
        };
      case "ads":
        return {
          background:
            "linear-gradient(to left, rgb(80,114,255), rgb(90,83,224)",
          color: "transparent",
          webkitBackgroundClip: "text"
        };
      case "lucky":
        return {
          background:
            "linear-gradient(to left, rgb(255,157,96), rgb(245,87,37)",
          color: "transparent",
          webkitBackgroundClip: "text"
        };
      default:
        return "";
    }
  }

  get localizedPrice() {
    return localizedPrice
  }

  private created() {}

  private mounted() {}
}
